<template>
    <button v-bind="attrs" type="button" role="button" :aria-label="ariaLabel" @click="navigate">
        <slot />
    </button>
</template>

<script setup lang="ts">
    import {computed, useAttrs, useSlots} from 'vue';
    import {safelyNavigateTo} from '@malt/utils';

    defineOptions({
        inheritAttrs: false,
    });

    type AuthLinkRole = 'signin' | 'signup';

    const AUTH_PATH_BY_ROLE: Record<AuthLinkRole, string> = {
        signin: '/signin',
        signup: '/who-are-you',
    };

    interface Props {
        role: AuthLinkRole;
        redirect?: string;
        pageSource?: string;
        componentSource?: string;
    }

    const {role, redirect, pageSource, componentSource} = defineProps<Props>();

    const attrs = useAttrs();

    const defaultSlot = useSlots().default?.();
    const ariaLabel = computed(() => {
        return defaultSlot?.map((v) => v.children).join('') ?? '';
    });

    async function navigate() {
        const path = AUTH_PATH_BY_ROLE[role];
        const query: Record<string, string> = {};

        if (componentSource) {
            query.componentSource = componentSource;
        }
        if (pageSource) {
            query.pageSource = pageSource;
        }
        if (redirect) {
            query.redirect = encodeURIComponent(redirect);
        }

        return safelyNavigateTo({path, query}, {externalToThisApp: true});
    }
</script>
